import { Injectable } from '@angular/core';

@Injectable()
export class VariantBase {
  variantGuid = '';
  variantName = '';
  variantAlternativeName = '';
  variantDineInPrice = 0;
  variantDineInPriceDiscounted = 0;
  variantDeliveryCollectionPrice = 0;
  variantDeliveryPriceDiscounted = 0;
  variantCollectionPriceDiscounted = 0;
  variantMaxPerOrder = 0;
  variantMaxPerDay = 0;
  allowCollection: boolean;
  allowDelivery: boolean;
  selected: boolean;
  variantTaxGuid = '';
  variantTaxRate = 0;
  variantDineInTaxAmt = 0;
  variantDeliveryTaxAmt = 0;
  variantCollectionTaxAmt = 0;
  variantAvailable: boolean;
  variantSKU = '';
  variantQty = 0;
  variantTaxEach = 0;
  VariantTotalTax = 0;
  VariantTotalPrice = 0;
  outofstock = false;
  totalDiscountAmount = 0;
  totalPriceAfterDiscount = 0;
  discountPercentage = 0;
  variantSalePrice = 0;
  variant_oadp = false;

  constructor(data?: Partial<VariantBase>) {
    Object.assign(this, data);

}
}
